// set available company ids...

const CompanyID = (a) => {

  console.log('companyID a: ' + a)

  const CompanyInfo = []
  let myID
  let myTheme

  switch (a) {
    case 'brotherhood.lmscourses.com':
      myID = 5503
      myTheme = 5503
      break

    case 'brotherhoodmutualcourses.com':
      myID = 5503
      myTheme = 5503
      break

    case 'www.brotherhoodmutualcourses.com':
      myID = 5503
      myTheme = 5503
      break

    case 'sgws.lmscourses.com':
      myID = 6572
      myTheme = 6572
      break

    case 'dpsg.lmscourses.com':
    case 'kdp.lmscourses.com':
      myID = 6403
      myTheme = 6403
      break

    case 'nextraq.lmscourses.com':
      myID = 8628
      myTheme = 8628
      break

    case 'foley.lmscourses.com':
      myID = 9566
      myTheme = 9566
      break

    case 'safetyalliance.lmscourses.com':
      myID = 10253
      myTheme = 10253
      break

    default:
      // default to DA courses...
      // myID = 6572
      // myTheme = 6572
      myID = 5191
      myTheme = 5191
      break
  }


  CompanyInfo.push(myID)
  CompanyInfo.push(myTheme)

  return CompanyInfo;

}

export default CompanyID
